import React, { useEffect, useState } from 'react';
// Libraries
import { Result } from 'antd';
// Components
import Button from '~/components/button';

export default function CompletedOperation({ operationResponse, intent }) {
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    if (seconds !== 0) {
      const interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      window.location.replace(intent.other_parameters.origin_url);
    }
  }, [seconds, intent]);

  return (
    <div>
      <Result
        status="success"
        title="Operação efetuada com sucesso!"
        subTitle={`Você será redirecionado em ${seconds} segundos`}
        extra={[
          <Button
            type="primary"
            key={1}
            onClick={() =>
              window.location.replace(intent.other_parameters.origin_url)
            }
          >
            Redirecionar agora
          </Button>,
        ]}
      />
    </div>
  );
}
